// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill';
import App from './App'
import router from './router'
import store from './store/'
import i18n from './i18n/i18n';
import messages from './i18n/langs/languages'
import $ from 'jquery';
import 'whatwg-fetch'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';


Vue.config.productionTip = false

Vue.use(ElementUI);

function isEmptyObject(e){
  let t;
  for (t in e)
    return !1;
  return !0
}


// let _srcJS='http://10.233.155.175:8081/deDEJS.js'
// appendJS(_srcJS)
// function appendJS(src){
//   if(src == sessionStorage.getItem('EVMLanguageJS')){
//   }else{
//     sessionStorage.setItem('EVMLanguageJS',src)
//     let script = document.createElement('script')
//     script.type = "text/javascript"
//     script.charset = "utf-8"
//     script.src = src
//     document.getElementsByTagName('body')[0].appendChild(script)
//   }
// }


// 自定义共同方法(this，MessgeName,type类型)
Vue.prototype.PublicMsg = function (that,msg,msgType){
  if(msg!=undefined){
    if(that.$t('list.'+msg).indexOf("list.") != -1){
      that.$message({
        message: msg,
        duration:3000,
        type: msgType
      });
    }else{
      that.$message({
        message: that.$t('list.'+msg),
        duration:3000,
        type: msgType
      });
    }
  }
}

// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   var str = to.meta.title.toLowerCase();
//   str = str.replace(/\b\w+\b/g, function(word){
//     return word.substring(0,1).toUpperCase()+word.substring(1);
//   });
//   document.title = str+" - Fresenius Medical Care"
//   next()
// })



// 无资源文件时报错问题
sessionStorage.setItem("EVMLanguage",'deDE');
try{
  for (let key of Object.keys(language)) {
    if(isEmptyObject(language[key])){
      messages[key].list = language.enUS;
    }else{
      messages[key]==null||messages[key]==undefined?'':messages[key].list = language[key];
    }
  }
}catch(e){
  // console.log(e.message);//sojson is undefined
}
router.beforeEach((to, from, next) => {
  let arr1 = location.href.split("?");
  if (arr1.length > 1) {
    if(arr1[1] == 'EVMTest'){
      sessionStorage.setItem('EVMTest','true')
    }
  }
  debugger
  document.title = to.meta.title+" - Fresenius Medical Care"
  let _url = ''
  if(Vue.prototype.isMaintence=='true'&&sessionStorage.getItem('EVMTest')!='true'){
    document.title = "Maintence - Fresenius Medical Care"
    if (to.matched.length === 0) {
      next('/maintenance') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
    }else{
      let _isOK = false
      for(let i=0;i<to.matched.length;i++){
        if(to.matched[i].path=='/maintenance'){
          _isOK = true
        }
      }
      if(_isOK == true){
        next()
      }else{
        next('/maintenance')
      }
    }
  }else{
    if (to.matched.length === 0) {
      next('/home') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
    }else{
      if(to.path=='/home'){
        next()
      }else{
        next()
      };
    }
  }
});


/* eslint-disable no-new */
// 定义外部接口可配置
import axios from 'axios'
let startApp = function () {
  axios.get('./static/config.json').then((res) => {
    // 基础地址
    Vue.prototype.isMaintence = res.data.isMaintence;
    Vue.prototype.MaintenceTime = res.data.MaintenceTime;
    Vue.prototype.BASE_URL = res.data.BASE_URL;
    Vue.prototype.Registered_URL = res.data.Registered_URL;
    Vue.prototype.OneTrust_URL = res.data.OneTrust_URL;
    Vue.prototype.OneTrust_URL2 = res.data.OneTrust_URL2;
    Vue.prototype.OneTrust_Append_URL = res.data.OneTrust_Append_URL;
    if($("script[src='"+res.data.OneTrust_URL+"']").length > 0){
      $("script[src='"+res.data.OneTrust_URL+"']").remove();
      $("script[src='"+res.data.OneTrust_URL2+"']").remove();
      $(document.head).append(res.data.OneTrust_Append_URL);
    }else{//未引用则引用
      $(document.head).append(res.data.OneTrust_Append_URL);
    }
    new Vue({
      el: '#app',
      router,
      store,
      i18n,
      components: { App },
      template: '<App/>'
    })
  })
}
 
startApp()




// WEBPACK FOOTER //
// ./src/main.js